// Content for Śrīmad-Bhāgavatam 1.2.7 commentary topic

import type { TopicContent } from '../types';

const content: TopicContent = {
    primarySloka: {
        reference: 'Srimad Bhagavatam 1.2.7',
        sloka: `vāsudeve bhagavati
bhakti-yogaḥ prayojitaḥ |
janayaty āśu vairāgyaṁ
jñānaṁ ca yad ahaitukam ||`,
        translation:
            'Bhakti dedicated to Lord Kṛṣṇa (<strong>vāsudeve bhagavati</strong>), endowed with special moods (<strong>bhakti-yogaḥ prayojitaḥ</strong>), quickly produces detachment from material goals (<strong>janayaty āśu vairāgyaṁ</strong>) and knowledge of the Lord devoid of the desire for liberation (<strong>jñānaṁ ca yad ahaitukam</strong>).',
    },
    blocks: [
        {
            type: 'text',
            content:
                'What form does that satisfaction of the mind take? <strong>This satisfaction of the mind is filled with knowledge and experience of the form, qualities and sweetness of the Lord, which cause complete disgust with all inferior objects.</strong> That is explained in this verse.<br /><br />This bhakti is endowed (yojitaḥ) in an excellent manner (pra for prakarṣeṇa), with dāsya, sakhya and other loving emotions. <strong>Another meaning of bhakti-yogaḥ prayojitaḥ is “bhakti-yoga has been made the only goal (prayojana).”</strong><br /><br /><strong>Separate endeavor for attaining knowledge and detachment are not necessary in the practice of bhakti, for bhakti itself produces them.</strong> Very quickly (āśu) at the time of performing bhakti, they are attained, for it is said:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 11.2.42',
                sloka: `bhaktiḥ pareśānubhavo viraktir
anyatra caiṣa trika eka-kālaḥ |
prapadyamānasya yathāśnataḥ syus
tuṣṭiḥ puṣṭiḥ kṣud-apāyo ’nu-ghāsam ||`,
                translation:
                    'Devotion, direct experience of the Supreme Lord, and detachment from other things-these three occur simultaneously for one who has taken shelter of the Supreme Personality of Godhead, in the same way that pleasure, nourishment and relief from hunger come simultaneously and increasingly, with each bite, for a person engaged in eating.',
            },
        },
        {
            type: 'text',
            content:
                'There is an objection that if one possesses knowledge, one attains liberation. In answer to this, the verse says that this knowledge is ahaitukam, without motivation for liberation.<br /><br /><strong>Ahaitukam comes from hetu, meaning cause or purpose, just as one can say “He lives for eating.” This means “He lives with the goal of eating.” Thus in this verse jnānam ahaitukam means “knowledge without the goal of liberation.”</strong><br /><br /><strong>Therefore by practicing bhakti in which knowledge also manifests without the goal of liberation, the liberation of merging does not take place. Knowledge in this case means knowledge and experience of the Lord’s form, qualities and sweetness.</strong>',
        },
        {
            type: 'text',
            content: 'Thus it is said in the Fourth Canto:',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 4.29.37',
                sloka: `vāsudeve bhagavati
bhakti-yogaḥ samāhitaḥ |
sadhrīcīnena vairāgyaṁ
jñānaṁ ca janayiṣyati ||`,
                translation:
                    'The stage of prema-bhakti completely dedicated to Vāsudeva, produces complete jñāna and vairāgya.',
            },
        },
        {
            type: 'text',
            content:
                '<strong>One should practice bhakti with only that goal in mind (sadhrīcīnena), devoid of desire for liberation or other goals.</strong><br /><br />The next verse shows that this type of bhakti is the cause of another type of bhakti.',
        },
        {
            type: 'sloka',
            sloka: {
                reference: 'Srimad Bhagavatam 4.29.38',
                sloka: `so ’cirād eva rājarṣe
syād acyuta-kathāśrayaḥ |
śṛṇvataḥ śraddadhānasya
nityadā syād adhīyataḥ ||`,
                translation:
                    'O saintly king! One who hears and studies with faith very soon attains the shelter topics of the Lord to attain prema.',
            },
        },
        {
            type: 'text',
            content:
                '<strong>Thus it is established in this verse that bhakti alone functions as both the cause and the goal (and not knowledge or detachment).</strong>',
        },
    ],
};

export default content;
